import styled from "styled-components";
import Icon from "../../../../components/Icon/Icon";
import { TILE_COLUMN_OPTIONS } from "../../../../hooks/useItemsViewPreferences";

const COLUMN_OPTION_COUNT = TILE_COLUMN_OPTIONS.length;

export const ControlsRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const SegmentedContainer = styled.div`
  position: relative;
  display: grid;
  flex-shrink: 0;
  height: 34px;
  padding: 3px;
  border: 1px solid ${({ theme }) => theme.formBorder};
  border-radius: 7px;
  background-color: ${({ theme }) => theme.inputBg};
  box-sizing: border-box;
`;

export const ModeContainer = styled(SegmentedContainer)`
  grid-template-columns: 1fr 1fr;
`;

export const ColumnsContainer = styled(SegmentedContainer)`
  grid-template-columns: repeat(${COLUMN_OPTION_COUNT}, 1fr);

  ${(props) => props.theme.xs`
    display: none;
  `}
`;

interface ThumbProps {
  $index: number;
}

/*
 * Sliding-thumb segmented control, same technique as SegmentedControl.styles:
 * the thumb is exactly one track wide — (100% - 2×3px container padding)
 * divided by the segment count — and translateX($index·100%) moves it in
 * own-width steps.
 */
const Thumb = styled.div<ThumbProps>`
  position: absolute;
  top: 3px;
  bottom: 3px;
  left: 3px;
  border-radius: 4px;
  background-color: ${({ theme }) => theme.primary10};
  transition: transform 0.2s ease-in-out;
  transform: translateX(${({ $index }) => $index * 100}%);
`;

export const ModeThumb = styled(Thumb)`
  width: calc(50% - 3px);
`;

export const ColumnsThumb = styled(Thumb)`
  width: calc(
    ${100 / COLUMN_OPTION_COUNT}% - ${6 / COLUMN_OPTION_COUNT}px
  );
`;

interface SegmentProps {
  $selected: boolean;
}

const Segment = styled.button<SegmentProps>`
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 9px;
  border: none;
  background: none;
  cursor: pointer;
  white-space: nowrap;
  font-family: inherit;
  font-size: 13px;
  font-weight: bold;
  color: ${({ theme, $selected }) =>
    $selected ? theme.primary : theme.black50};
  transition: color 0.2s ease-in-out;

  &:hover {
    color: ${({ theme, $selected }) =>
      $selected ? theme.primary : theme.black};
  }
`;

export const ModeSegment = styled(Segment)`
  i {
    background-color: ${({ theme, $selected }) =>
      $selected ? theme.primary : theme.black50};
    transition: background-color 0.2s ease-in-out;
  }

  &:hover i {
    background-color: ${({ theme, $selected }) =>
      $selected ? theme.primary : theme.black};
  }
`;

export const ColumnsSegment = styled(Segment)``;

export const ModeIcon = styled(Icon)`
  width: 15px;
  height: 15px;
`;
